/**
 * @description: 获取地址栏参数
 * @param name 
 * @returns string || null
 */
//获取地址栏参数
export const getUrlParams = (name: string): string => {
    const splitUrl = window.location.href.split("?")[1];
    if (!splitUrl) return '';
    const str = splitUrl.split("#")[0];
    if (!str) return '';
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$|#)");
    const result = str.match(reg);
    if (result !== null) return result[2];
    else return '';
}